module.exports = __webpack_public_path__ + "static/img/community14.bf85a47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/community14.png
// module id = 8rqk
// module chunks = 0